<template>
  <div class="carousel-container">
    <!-- 大图轮播区域 -->
    <div class="main-carousel">
      <transition :name="transitionEffect">
        <div 
          class="slide" 
          :key="activeIndex"
          @mouseenter="pauseAutoPlay"
          @mouseleave="startAutoPlay"
        >
          <img :src="images[activeIndex].large" :alt="images[activeIndex].alt">
        </div>
      </transition>
      
      <!-- 左右箭头 -->
      <button class="arrow prev" @click="prevSlide"><img src="@/assets/left.png" alt=""></button>
      <button class="arrow next" @click="nextSlide"><img src="@/assets/right.png" alt=""></button>
    </div>

    <!-- 小图预览 -->
    <div class="thumbnail-container">
      <div
        v-for="(image, index) in images"
        :key="index"
        class="thumbnail"
        :class="{ active: index === activeIndex }"
        @click="goToSlide(index)"
      >
        <img :src="image.small" :alt="image.alt">
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'

const props = defineProps({
  images: {
    type: Array,
    required: true,
    validator: value => value.every(img => 'large' in img && 'small' in img)
  },
  interval: {
    type: Number,
    default: 5000
  }
})

const activeIndex = ref(0)
const transitionEffect = ref('slide')
let autoPlayTimer = null

// 自动播放控制
const startAutoPlay = () => {
  autoPlayTimer = setInterval(() => {
    nextSlide()
  }, props.interval)
}

const pauseAutoPlay = () => {
  clearInterval(autoPlayTimer)
}

// 切换逻辑
const prevSlide = () => {
  transitionEffect.value = 'slide-prev'
  activeIndex.value = activeIndex.value > 0 
    ? activeIndex.value - 1 
    : props.images.length - 1
}

const nextSlide = () => {
  transitionEffect.value = 'slide-next'
  activeIndex.value = activeIndex.value < props.images.length - 1 
    ? activeIndex.value + 1 
    : 0
}

const goToSlide = (index) => {
  transitionEffect.value = index > activeIndex.value ? 'slide-next' : 'slide-prev'
  activeIndex.value = index
}

// 生命周期
onMounted(startAutoPlay)
onBeforeUnmount(() => {
  clearInterval(autoPlayTimer)
})
</script>

<style scoped>
.carousel-container {
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
}

.main-carousel {
  position: relative;
  height: 366px;
  width: 606px;
  overflow: hidden;
}

.slide {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.5s ease;
}

.slide img {
  height: 366px;
  width: 606px;
}

.arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(0,0,0,0.5);
  color: white;
  border: none;
  padding: 16px;
  cursor: pointer;
  font-size: 20px;
  transition: 0.3s;
  background: rgba(0, 0, 0, 0.20);
}

.arrow:hover {
  
}

.prev { left: 0px; }
.next { right: 0px; }

.thumbnail-container {
  display: flex;
  justify-content: center;
  gap: 9px;
  margin-top: 10px;
}

.thumbnail {
  width: 196px;
  height: 114px;
  cursor: pointer;
  border: 2px solid transparent;
  opacity: 1;
  transition: 0.3s;
  box-sizing: border-box;
}

.thumbnail:hover,
.thumbnail.active {
  opacity: 0.7;
  /* border-color: #10338A; */
}

.thumbnail img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 过渡动画 */
.slide-next-enter-active,
.slide-next-leave-active,
.slide-prev-enter-active,
.slide-prev-leave-active {
  transition: all 0.5s ease;
}

.slide-next-enter-from {
  transform: translateX(100%);
}
.slide-next-leave-to {
  transform: translateX(-100%);
}

.slide-prev-enter-from {
  transform: translateX(-100%);
}
.slide-prev-leave-to {
  transform: translateX(100%);
}
</style>
